import { useTranslation } from 'react-i18next';
import MonthlyReportView from '../MonthlyReportView';

export default function AdminReportsPage() {
  const { t } = useTranslation();
  return (
    <MonthlyReportView
      title={t('admin.reportsTitle')}
      queryKey={['admin', 'reports', 'monthly']}
      reportUrl="/admin/reports/monthly"
      multi
      exportUrl="/admin/reports/monthly/export"
      exportFilename="admin-monthly.csv"
    />
  );
}
